(function () {
  'use strict';

  var FADE_MS = 300;
  var OUTGOING_DELAY_MS = 150;

  function isMobile() {
    return window.innerWidth < 750;
  }

  function initFeaturedCollectionSplit(section) {
    var items = section.querySelectorAll('.fcs__product-item');
    var cards = section.querySelectorAll('.fcs__product-card');
    var sliderEl = section.querySelector('[id^="Slider-"]');
    var sliderComponent = section.querySelector('slider-component');

    if (!items.length || !cards.length) return;

    var activeIndex = 0;
    var pending = null;

    function activate(index) {
      if (index === activeIndex) return;

      var prevIndex = activeIndex;
      activeIndex = index;

      if (pending) {
        clearTimeout(pending);
        pending = null;
      }

      // Always sync list items
      items.forEach(function (item, i) {
        item.classList.toggle('is-active', i === index);
      });

      if (isMobile()) {
        // On mobile just toggle is-active on cards; CSS handles the opacity
        cards.forEach(function (card, i) {
          card.classList.toggle('is-active', i === index);
        });
        return;
      }

      // Desktop: crossfade
      var incoming = cards[index];
      incoming.style.zIndex = 2;
      incoming.classList.add('is-active');

      var outgoing = cards[prevIndex];
      outgoing.style.zIndex = 1;
      pending = setTimeout(function () {
        pending = null;
        outgoing.classList.remove('is-active');
        setTimeout(function () {
          outgoing.style.zIndex = '';
          incoming.style.zIndex = '';
        }, FADE_MS);
      }, OUTGOING_DELAY_MS);
    }

    // Desktop: hover activates cards
    items.forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        if (!isMobile()) activate(parseInt(item.dataset.productIndex, 10));
      });

      item.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          activate(parseInt(item.dataset.productIndex, 10));
        }
      });

      // Mobile: tap a list item to scroll its card into view
      item.addEventListener('click', function (e) {
        if (!isMobile()) return;
        var idx = parseInt(item.dataset.productIndex, 10);
        var card = cards[idx];
        if (card && sliderEl) {
          e.preventDefault();
          sliderEl.scrollTo({ left: card.offsetLeft, behavior: 'smooth' });
        }
      });
    });

    // Mobile: SliderComponent fires slideChanged on each scroll snap
    if (sliderComponent) {
      sliderComponent.addEventListener('slideChanged', function (e) {
        if (!isMobile()) return;
        activate(e.detail.currentPage - 1);
      });
    }
  }

  function init() {
    document.querySelectorAll('.featured-collection-split').forEach(initFeaturedCollectionSplit);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.featured-collection-split');
    if (section) initFeaturedCollectionSplit(section);
  });
})();